﻿@Component('Umbrella', {
    selector: 'prospect-role-label',
    template: `
        <role-label label-text="WZ" label-title="Woningzoekende"></role-label>
    `
})
class ProspectRoleLabelComponent {}
